import React from 'react'

const CompanyCard=(props)=>{
  return(
    <div className='card'>
      <div className="companyLogoContainer">
        <a href={props.data.url} target="_blank" rel="noopener noreferrer"><img src={props.data.image.fields.file.url} className='companyLogo' alt=''/></a>
      </div>
      <div className='companyInfo'>
        <p　className='companyName'>{props.data.name}</p>  
        <p　className='subTitle'>業種</p>  
        <p　className='explain'>{props.data.type}</p>  
        <p　className='subTitle'>募集職種</p>  
        <p　className='explain'>{props.data.recruitment}</p>  
        <p　className='subTitle'>説明</p>  
        <p　className='explain'>{props.data.description}</p>  
      </div>
    </div>
  )
}

export default CompanyCard